import {css} from "styled-components";
import {getButtonPaddings} from "@/components/UI/Button/Button.utils";
import {getFontSize, getLetterSpacing} from "@/pipes/theme.pipe";

const sizeOptions = {
    xs: css`
        font-size: clamp(${getFontSize('button', 'xs')}, 4vw, ${getFontSize('button', 'xs')});
        letter-spacing: ${getLetterSpacing('xs')};
        line-height: 20px;
        ${getButtonPaddings('xs')};
    `,
    sm: css`
        font-size: clamp(${getFontSize('button', 'xs')}, 4vw, ${getFontSize('button', 'sm')});
        letter-spacing: ${getLetterSpacing('sm')};
        line-height: 12px;
        ${getButtonPaddings('sm')};
    `,
    md: css`
        font-size: clamp(${getFontSize('button', 'xs')}, 4vw, ${getFontSize('button', 'sm')});
        letter-spacing: ${getLetterSpacing('md')};
        ${getButtonPaddings('md')};
    `,
    lg: css`
        font-size: clamp(${getFontSize('button', 'xs')}, 3vw, ${getFontSize('button', 'lg')});
        letter-spacing: clamp(${getLetterSpacing('md')}, 4vw, ${getLetterSpacing('lg')});
        ${getButtonPaddings('lg')};
    `,
    xl: css`
        font-size: clamp(${getFontSize('button', 'md')}, 4vw, ${getFontSize('button', 'lg')});
        letter-spacing: ${getLetterSpacing('xl')};
        ${getButtonPaddings('xl')};
    `,
    auto: css`
        width: fit-content;
        padding: 0;
        letter-spacing: ${getLetterSpacing('md')};
    `
}

export const getSizeStyles = ({size}) => sizeOptions[size] ?? sizeOptions['md']